import React from 'react'

import { Spinner } from '@telavita-core/react-design-kit'

import * as S from '../styles'

interface LoadingProps {
  professionalRole: 'psicólogo' | 'psiquiatra'
}

export const Loading = ({ professionalRole }: LoadingProps): JSX.Element => {
  return (
    <>
    <S.SpinnerContainer>
      <Spinner customClassName='RequestTreatmentModal__Spinner'/>
    </S.SpinnerContainer>
    <S.PulseTitle data-cy='request-treatment-loading'>
      Solicitando consulta com <br /> {professionalRole}
    </S.PulseTitle>
  </>
  )
}